import React from 'react';

function Footer({ socials }) {
  return (
    <footer className="border-t border-ink/10 bg-snow/70">
      <div className="section-wrap flex flex-col items-center justify-between gap-6 py-8 md:flex-row">
        <p className="text-[10px] uppercase tracking-[0.2em] text-ink/45">
          © {new Date().getFullYear()} Nithin Sai Choudray. All Rights Reserved.
        </p>

        <div className="flex flex-wrap justify-center gap-5">
          {socials.map((social) => (
            <a
              key={social.label}
              href={social.href}
              target="_blank"
              rel="noreferrer"
              className="ui-nav-link text-[10px] uppercase tracking-[0.2em] text-ink/45 hover:text-ink"
            >
              {social.label}
            </a>
          ))}
        </div>
      </div>
    </footer>
  );
}

export default Footer;
